import { createContext, useContext, useEffect, useState } from 'react'
import { read, write } from '../lib/storage.js'

const ThemeContext = createContext(null)

export function ThemeProvider({ children }) {
  // Deterministic initial value so the prerendered HTML and the client's first
  // render match — otherwise the theme-toggle icon differs and hydration fails.
  // The real (saved/system) theme is adopted right after mount. An inline script
  // in index.html sets <html data-theme> before paint, so there's no flash.
  const [theme, setTheme] = useState('light')
  const [mounted, setMounted] = useState(false)

  // Adopt the saved / system preference once, on the client, after hydration.
  useEffect(() => {
    const saved = read('theme')
    setTheme(saved || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'))
    setMounted(true)
  }, [])

  useEffect(() => {
    if (!mounted) return // don't clobber the pre-paint value during first render
    document.documentElement.setAttribute('data-theme', theme)
    write('theme', theme)
  }, [theme, mounted])

  const toggle = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'))

  return <ThemeContext.Provider value={{ theme, toggle }}>{children}</ThemeContext.Provider>
}

export const useTheme = () => useContext(ThemeContext)
